import { render, staticRenderFns } from "./RutaDetalle.vue?vue&type=template&id=615d8cb6"
import script from "./RutaDetalle.vue?vue&type=script&lang=js"
export * from "./RutaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports